@if (!inputService.hidden && inputService.formInputDefinition && show) {
  <div class='info-field readonly-field'>
    <span class='info-head' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.computedTitle | translate}}</span>
    <br>
      @if (!loading) {
        <span class='info-value'> {{computedValue}} </span>
      }
    </div>
  }